import {Component, EventEmitter, Inject, OnInit, Output, Renderer2, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {UpdatePureOriginalModel} from "../../models/UpdatePureOriginal-model";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Clipboard} from '@angular/cdk/clipboard';
import {AddDialogComponent} from "../../helpers/add-dialog/add-dialog.component";
import {CorrectEcuProducersModel, EcuBuildNameModel} from "../../models/EcuBuildName-model";
import {AddEcuProducerDialogComponent} from "../../helpers/add-ecu-producer-dialog/add-ecu-producer-dialog.component";
import {EcuNamesService} from "../../service/Ecu-names.service";
import {NotificationService} from "../../service/Notification.service";

@Component({
    selector: 'app-edit-pure-original-dialog',
    templateUrl: './edit-pure-original-dialog.component.html',
    styleUrls: ['./edit-pure-original-dialog.component.css']
})
export class EditPureOriginalDialogComponent implements OnInit {
    public contentToShow: UpdatePureOriginalModel;
    public prevPureOriginalFormState: string;
    public ecuBuild: EcuBuildNameModel;
    public ecuProducer: CorrectEcuProducersModel;
    public searchQuery: string = '';
    public activeTab = signal<'build' | 'details'>('details');

    @Output() pureOriginalEcuBuildChangeEmitter = new EventEmitter<string>();

    @Output() pureOriginalEcuProducerChangeEmitter = new EventEmitter<string>();

    constructor(private ecuNamesService: EcuNamesService, private notificationService: NotificationService, private dialog: MatDialog, public dialogRef: MatDialogRef<EditPureOriginalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: {
        id: string,
        text: string,
        content: UpdatePureOriginalModel
    }, private renderer: Renderer2, private clipboard: Clipboard) {

        this.getEcuName();
    }

    get requiredFieldsFilled(): boolean {
        return this.editPureOriginalForm.valid;
    }

    getRefToClipboard() {
        this.clipboard.copy(this.data['text']);
    }

    editPureOriginalForm = new FormGroup({
        vehicleProducer: new FormControl('', Validators.required),
        vehicleSeries: new FormControl('', Validators.required),
        vehicleType: new FormControl('', Validators.required),
        vehicleModel: new FormControl(''),
        vehicleModelYear: new FormControl(''),
        vehicleBuild: new FormControl(''),
        vehicleCharacteristic: new FormControl(''),
        ecuSoftwareVersion: new FormControl(''),
        ecuUse: new FormControl(''),
        ecuBuild: new FormControl('', Validators.required),
        ecuProducer: new FormControl('', Validators.required),
        ecuProdNr: new FormControl(''),
        ecuStgNr: new FormControl(''),
        engineDisplacement: new FormControl(0, [Validators.pattern(/^\d+(\.\d+)?$/)]),
        engineMaxTorque: new FormControl(0, [Validators.pattern(/^\d+(\.\d+)?$/)]),
        engineName: new FormControl(''),
        engineProducer: new FormControl(''),
        engineType: new FormControl(''),
        engineTransmission: new FormControl(''),
        outputPs: new FormControl(0, [Validators.pattern(/^\d+(\.\d+)?$/)]),
        outputKw: new FormControl(0, [Validators.pattern(/^\d+(\.\d+)?$/)]),
        readingHardware: new FormControl(''),
        ecuSoftwareVersionVersion: new FormControl(''),
        engineEmission: new FormControl(''),
        projectComment: new FormControl(''),
        versionComment: new FormControl(''),
        projectType: new FormControl('')
    });


    ngOnInit() {

        this.contentToShow = this.data['content'];
        this.editFormValue();
        this.editPureOriginalForm.get('ecuBuild').markAsTouched();
        this.editPureOriginalForm.get('ecuBuild').setErrors({'valid': true});
        this.editPureOriginalForm.get('ecuProducer').markAsTouched();
        this.editPureOriginalForm.get('ecuProducer').setErrors({'valid': true});
        this.editPureOriginalForm.get('ecuBuild').markAsTouched();
        this.editPureOriginalForm.get('engineType').markAsTouched();
        this.editPureOriginalForm.get('engineType').setErrors({'valid': true});
        this.getEcuName();
    }


    editFormValue() {
        this.prevPureOriginalFormState = this.contentToShow.ecuBuild;

        this.editPureOriginalForm.setValue({
            vehicleProducer: this.contentToShow.vehicleProducer || '',
            vehicleSeries: this.contentToShow.vehicleSeries || '',
            vehicleModel: this.contentToShow.vehicleModel || '',
            vehicleModelYear: this.contentToShow.vehicleModelYear || '',
            vehicleBuild: this.contentToShow.vehicleBuild || '',
            vehicleCharacteristic: this.contentToShow.vehicleCharacteristic || '',
            ecuSoftwareVersion: this.contentToShow.ecuSoftwareVersion || '',
            ecuUse: this.contentToShow.ecuUse || '',
            ecuBuild: this.contentToShow.ecuBuild || '',
            ecuProducer: this.contentToShow.ecuProducer || '',
            ecuProdNr: this.contentToShow.ecuProdNr || '',
            ecuStgNr: this.contentToShow.ecuStgNr || '',
            engineDisplacement: this.contentToShow.engineDisplacement || 0,
            engineMaxTorque: this.contentToShow.engineMaxTorque || 0,
            engineName: this.contentToShow.engineName || '',
            engineProducer: this.contentToShow.engineProducer || '',
            engineType: this.contentToShow.engineType || '',
            engineTransmission: this.contentToShow.engineTransmission || '',
            outputPs: this.contentToShow.outputPs || 0,
            outputKw: this.contentToShow.outputKw || 0,
            readingHardware: this.contentToShow.readingHardware || '',
            vehicleType: this.contentToShow.vehicleType || '',
            ecuSoftwareVersionVersion: this.contentToShow.ecuSoftwareVersionVersion || '',
            engineEmission: this.contentToShow.engineEmission || '',
            projectComment: this.contentToShow.projectComment || '',
            versionComment: this.contentToShow.versionComment || '',
            projectType: this.contentToShow.projectType || ''
        });
    }

    getValidationErrors(): string[] {
        const errors: string[] = [];

        Object.keys(this.editPureOriginalForm.controls).forEach(controlName => {
            const control = this.editPureOriginalForm.get(controlName);
            const capitalized = controlName.charAt(0).toUpperCase() + controlName.slice(1).toLowerCase();

            if (control && control.invalid && control.errors) {
                const controlErrors = control.errors;
                Object.keys(controlErrors).forEach(errorKey => {
                    let message: string;
                    switch (errorKey) {
                        case 'required':
                            message = `${capitalized} is required`;
                            break;
                        case 'pattern':
                            message = `${controlName} has an invalid format`;
                            break;
                        // If you have custom validators, add more cases here.
                        default:
                            message = `${controlName} has error: ${errorKey}`;
                    }
                    errors.push(message);
                });
            }
        });
        return errors;
    }

    getEcuName() {
        this.editPureOriginalForm.get('ecuBuild').valueChanges.subscribe(response => {
            this.searchQuery = response
        });
    }

    focusOnDialogElement() {
        const firstDialogElement = this.renderer.selectRootElement('#firstDialogElement');
        if (firstDialogElement) {
            firstDialogElement.focus();
        }
    }

    addNewEcu() {
        this.dialog.open(AddDialogComponent, {
            width: "560px",
            panelClass: "form-dialog-v3-panel",
            data: {ecuBuildValue: this.editPureOriginalForm.get('ecuBuild').value}
        }).afterClosed().subscribe((value: {
            closed: boolean,
            ecu: EcuBuildNameModel
        }) => {
            if (value.closed) {
                this.editPureOriginalForm.patchValue({
                    ecuBuild: value.ecu.correctEcuBuildNames
                })
                this.ecuBuild = value.ecu;
                this.focusOnDialogElement();
            }
        });
    }

    focusOnEcuProducerElement() {
        const secondDialogElement = this.renderer.selectRootElement('#secondDialogElement');
        if (secondDialogElement) {
            secondDialogElement.focus();
        }
    }

    addNewEcuProducer() {
        this.dialog.open(AddEcuProducerDialogComponent, {
            width: "520px",
            panelClass: "form-dialog-v3-panel",
            data: {ecuProducerValue: this.editPureOriginalForm.get('ecuProducer').value}
        }).afterClosed().subscribe((value: {
            closed: boolean,
            ecuProducer: CorrectEcuProducersModel
        }) => {
            if (value.closed) {
                this.editPureOriginalForm.patchValue({
                    ecuProducer: value.ecuProducer.correctEcuProducer,
                })
                this.ecuProducer = value.ecuProducer;
                this.focusOnEcuProducerElement();
            }
        });
    }


    canceledOption() {
        this.dialogRef.close({closed: false});
    }

    confirmedOption() {
        this.onEcuBuildChange();
        const content = this.editPureOriginalForm.value as UpdatePureOriginalModel;
        const id = this.data.id;
        this.dialogRef.close({
            closed: true,
            content: content,
            id: id,
            prevEcuBuildState: this.prevPureOriginalFormState
        });
    }

    onEcuBuildChange() {
        const ecuBuildValue = this.editPureOriginalForm.get('ecuBuild')?.value;
        this.pureOriginalEcuBuildChangeEmitter.emit(ecuBuildValue)
    }

    getCorrectEcuName($event: any) {
        console.log($event.valueOf());
        this.editPureOriginalForm.patchValue({
            ecuBuild: $event.valueOf(),
        });
        this.ecuNamesService.getValidEcuProducerByEcuBuild($event.valueOf()).subscribe((response) => {

                    this.editPureOriginalForm.patchValue({
                        ecuProducer: response.body["ecuProducer"],
                    });

            }, (error) => {
                this.notificationService.showErrorMessage(`${error.error.message}`, "Error occurred!");
            }
        );
    }
}
